import {Route, Routes} from "react-router";
import {AuthLayout} from "./layouts/AuthLayout";
import {AppLayout} from "./layouts/AppLayout";
import {AdminLayout} from "./layouts/AdminLayout";
import {LoginContainer} from "./containers/Login";
import {SpreadsheetContainer} from "./containers/Spreadsheet";
import {AuctionContainer} from "./containers/Auction";
import {TradeContainer} from "./containers/Trade";
import {DropContainer} from "./containers/Drop";
import {PreDraftContainer} from "./containers/PreDraft";
import {DraftContainer} from "./containers/Draft";
import {DraftTradeContainer} from "./containers/DraftTrade";
import {HistoryContainer} from "./containers/History";
import {RecordsContainer} from "./containers/Records";
import {StatsContainer} from "./containers/Stats";
import {ActivityContainer} from "./containers/Activity";
import {WinsPoolContainer} from "./containers/WinsPool";
import {SettingsContainer} from "./containers/Settings";
import {AdminContainer} from "./containers/Admin";
import {AuditContainer} from "./containers/Audit";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";

export const App = () => {
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <Routes>
                    <Route element={<AuthLayout/>}>
                        <Route index element={<LoginContainer/>}/>
                    </Route>
                    <Route element={<AppLayout/>}>
                        <Route path="rosters" element={<SpreadsheetContainer/>}/>
                        <Route path="auction" element={<AuctionContainer/>}/>
                        <Route path="trade" element={<TradeContainer/>}/>
                        <Route path="drop" element={<DropContainer/>}/>
                        <Route path="predraft" element={<PreDraftContainer/>}/>
                        <Route path="draft" element={<DraftContainer/>}/>
                        <Route path="drafttrade" element={<DraftTradeContainer/>}/>
                        <Route path="history" element={<HistoryContainer/>}/>
                        <Route path="records" element={<RecordsContainer/>}/>
                        <Route path="stats" element={<StatsContainer/>}/>
                        <Route path="activity" element={<ActivityContainer/>}/>
                        <Route path="wins" element={<WinsPoolContainer/>}/>
                        <Route path="settings" element={<SettingsContainer/>}/>
                        <Route element={<AdminLayout/>}>
                            <Route path="admin" element={<AdminContainer/>}/>
                            <Route path="audit" element={<AuditContainer/>}/>
                        </Route>
                    </Route>
                </Routes>
            </LocalizationProvider>
        </div>
    );
}
